import { contextFactory } from '@frontend/design-system';
import { UseFormsClonerProviderResults } from './hooks';

export const [FormsClonerContext, useFormsClonerContext] = contextFactory<UseFormsClonerProviderResults>();
